import { Accordion, Badge, Col, Container, Nav, Row } from 'react-bootstrap'
import service_bg from './../../assets/service_bg.png'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Button } from 'react-bootstrap'
import solution_data from './../../data/solutions'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

function Solution () {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const url = pathSegments[pathSegments.length - 1] || '';
  const [data, setData] = useState({})

  useEffect(() => {
    const dataTemp = solution_data.find(x => x.url === url)
    if(dataTemp){
      setData(dataTemp)
    }else{
      MySwal.fire({
        title: 'Error',
        text: 'Something went wrong...',
        icon: 'error'
      })
      navigate('/')
    }
  }, [url])

  return(
    <div className='wrap-hidden'>
      <div className='pb-5 pt-5'
        style={{
          backgroundImage: `url(${service_bg})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "100% auto",
        }}
      >
        <Container className='mt-5 pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='mt-5 header text-center'>{data.title}</div>
            <p className='mt-4 text-center'>{data.desc}</p>
            <div className='mt-4 text-center'>
              <Nav.Link href="/#demo-form">
                <Button variant='brand'>Book Demo</Button>
              </Nav.Link>
            </div>
          </AnimationOnScroll>

          <div className='mt-5 card-shadow'>
            <div className='bg-main-secondary-light pt-5 pb-5 ps-2 pe-2'>
              <h3 className='text-center'><Badge bg="brand-secondary">The Challenge</Badge></h3>
              <div className='header text-center'>{data.challenge}</div>
            </div>
            <div className='p-5 category ps-5 pe-5'>
              <p className='text-center'>{data.challenge_desc}</p>
              <div className='mt-5'>
                <Row className='category'>
                  {
                    data?.partner_info?.map((item, index) => (
                      <Col key={'partner-'+index} xs={12} md className='mb-4'>
                        <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0*index} offset={100} style={{height:"100%"}}>
                          <div className='card-shadow p-3 text-center' style={{ borderRadius:15, height: "100%" }}>
                            {/* <img src={icon1} style={{width:"50px", height: "50px"}} alt=""/> */}
                            <div className='text-center mt-1'><strong>{item.title}</strong></div>
                            <p className='text-center mt-2'>{item.description}</p>
                          </div>
                        </AnimationOnScroll>
                      </Col>
                    ))
                  }
                </Row>
              </div>
              <div className='mt-4 text-center'>
                <Nav.Link href="/#demo-form">
                  <Button variant='brand'>Book Demo</Button>
                </Nav.Link>
              </div>
              <div className='mt-5'>
                {
                  data?.features?.map((item, index) => (
                    <Row key={"feature-"+index} className='align-items-center'>
                      <Col xs={12} md={6} className='mb-4'>
                        {
                          index%2 === 0 ? (
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                              <h4><strong>{item.title}</strong></h4>
                              <div dangerouslySetInnerHTML={{ __html: item.description }}/>
                            </AnimationOnScroll>
                          ) : (
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                              <img src={item.image} style={{width:'100%'}} alt=""/>
                            </AnimationOnScroll>
                          )
                        }
                      </Col>
                      <Col xs={12} md={6} className='mb-4'>
                        {
                          index%2 === 0 ? (
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                              <img src={item.image} style={{width:'100%'}} alt=""/>
                            </AnimationOnScroll>
                          ) : (
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                              <h4><strong>{item.title}</strong></h4>
                              <div dangerouslySetInnerHTML={{ __html: item.description }}/>
                            </AnimationOnScroll>
                          )
                        }
                      </Col>
                    </Row>
                  ))
                }
              </div>
              <div className='mt-4 text-center'>
                <Nav.Link href="/#demo-form">
                  <Button variant='brand'>Book Demo</Button>
                </Nav.Link>
              </div>
            </div>
          </div>
        </Container>
        {
          data.faqs && data?.faqs?.length > 0 &&
          <Container className='pb-5'>
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
              <div className='header text-center'>Frequently  <span className="text-brand-secondary">Asked Questions</span></div>
            </AnimationOnScroll>
            <div className='mt-4'>
              <Accordion className='topic-wrapper'>
                {
                  data?.faqs?.map((item, index) => (
                    <Accordion.Item key={"faqs-"+index} eventKey={index} className="mb-2">
                      <Accordion.Header>{item.question}</Accordion.Header>
                      <Accordion.Body>
                        <div dangerouslySetInnerHTML={{ __html: item.answer }}/>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                }
              </Accordion>
            </div>
          </Container>
        }
      </div>
    </div>
  )
}

export default Solution